import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { FileDown, Mail, HeartPulse } from "lucide-react";
import { useApi, errMsg, lastMonth } from "../lib/api";
import { useMember } from "../lib/member";
import { MonthPicker } from "./DateField";

export const HealthReport = () => {
  const api = useApi();
  const { me } = useMember();
  const [q] = useSearchParams();
  const [month, setMonth] = useState(q.get("health") || lastMonth());
  const [busy, setBusy] = useState("");
  const download = async () => {
    setBusy("pdf");
    try {
      const r = await api.get("/reports/health.pdf", { params: { month }, responseType: "blob" });
      const a = document.createElement("a"); a.href = URL.createObjectURL(r.data); a.download = `Compliance_health_${month}.pdf`; a.click();
      setTimeout(() => URL.revokeObjectURL(a.href), 1000);
    } catch (e) { toast.error(errMsg(e)); }
    setBusy("");
  };
  const send = async () => {
    setBusy("mail");
    try { const r = (await api.post("/reports/health/send", null, { params: { month } })).data; toast.success(`Health report for ${r.month} emailed to ${r.sent} recipient(s)`); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy("");
  };
  return (
    <div className="c-surface p-5 c-rise mb-6 flex flex-col md:flex-row md:items-center gap-4" data-testid="health-report-card">
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 font-semibold"><HeartPulse size={16} className="text-[#00E599]" />Monthly health report</div>
        <p className="text-xs text-slate-400 mt-1">{me?.role === "vendor"
          ? "One-page PDF of your score, penalties, holds, minimum-wage gaps, missing challans and CLRA licence, with what to fix. Emailed to you on the 20th."
          : "PDF on your letterhead with every contractor's score, penalties, holds, minimum-wage gaps, missing challans and CLRA licences, with what each needs to fix. Emailed automatically on the 20th to company admins, each principal employer and each contractor (its own page)."}</p>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <MonthPicker value={month} onChange={setMonth} testid="health-report-month" className="w-40" />
        <button onClick={download} disabled={!!busy} className="inline-flex items-center gap-1.5 rounded-md bg-[#00E599] px-3 py-2 text-sm font-semibold text-[#0B1017] disabled:opacity-50" data-testid="health-report-download">
          <FileDown size={14} />{busy === "pdf" ? "Preparing…" : "Download PDF"}</button>
        {me?.role === "admin" && <button onClick={send} disabled={!!busy} className="inline-flex items-center gap-1.5 rounded-md border border-[#1F2A3E] px-3 py-2 text-sm hover:bg-[#1A2234] disabled:opacity-50" data-testid="health-report-send">
          <Mail size={14} />{busy === "mail" ? "Sending…" : "Email now"}</button>}
      </div>
    </div>);
};
